import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Button } from '../../../../components/ui/button.jsx';
import { languagePrefixes } from '../../../../i18n';
import googleLogo from '../../../../pages/authentication/google-logo.svg';
import LastDealsInline from './LastDealsInline.jsx';

const FoundersHeroWithDeals = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const currentLanguage = (i18n.language || 'en').split('-')[0];
  const prefix = languagePrefixes[currentLanguage] || '';

  const handleSignUpClick = () => {
    navigate(
      `${prefix}/signup?utm_source=signup-button&utm_medium=for-early-stage-startup-founders-page`
    );
  };

  return (
    <section className="py-16 sm:py-24 bg-slate-100">
      <div className="w-[75%] mx-auto max-w-6xl">
        <div className="lg:grid lg:grid-cols-[0.35fr,0.65fr] lg:gap-10 items-start">
          {/* Left column ~30% — heading and text */}
          <div className="text-center lg:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-stone-900">
              {t(
                'pageSolutions.EarlyStageFounders.t19',
                'See real Pre-Seed & Seed-stage activity'
              )}
            </h1>

            <p className="mt-6 text-base sm:text-lg leading-7 text-stone-700 max-w-xl mx-auto lg:mx-0">
              {t(
                'pageSolutions.EarlyStageFounders.t20',
                'Explore the latest early-stage funding rounds from startups like yours. On Crino, you can dive deeper into each deal — investor profiles, co-investors, industry focus and complete investment history — and access many more early-stage transactions.'
              )}
            </p>

            <div className="mt-8 flex justify-center lg:justify-start">
              <Button
                onClick={handleSignUpClick}
                variant="default"
                size="sm"
                iconLeft={
                  <>
                    <Mail className="h-4 w-4 mr-2" />
                    <img
                      src={googleLogo}
                      alt="Google logo"
                      className="h-4 w-4"
                    />
                  </>
                }
              >
                {t('pageHome.content.t4')}
              </Button>
            </div>
          </div>

          {/* Right column ~70% — latest deals list */}
          <div className="mt-10 lg:mt-0">
            <LastDealsInline className="w-full" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersHeroWithDeals;
